import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Card, FloatButton } from 'antd';
import { AliwangwangOutlined, CloseOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router';

const ChatContainer = styled(Card)<{ $isOpen: boolean }>`
  position: fixed;
  bottom: 130px;
  right: 24px;
  width: 400px;
  height: 600px;
  display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
  flex-direction: column;
  box-shadow:
    0 6px 16px 0 rgba(0, 0, 0, 0.08),
    0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 9px 28px 8px rgba(0, 0, 0, 0.05);
  z-index: 1000;

  .ant-card-body {
    padding: 0;
    height: 100%;
    overflow: hidden;
  }
`;

const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: 2px solid #f0f0f0;
`;

const Agent: React.FC<{ userToken: string; locale: string }> = ({
  userToken,
  locale,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isServerAvailable, setIsServerAvailable] = useState(false);
  const [iframeKey, setIframeKey] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const checkServerHealth = async () => {
      try {
        const response = await fetch('https://pos-agent-aws.inventorum.com/', {
          method: 'HEAD',
          mode: 'no-cors',
        });
        setIsServerAvailable(response.type === 'opaque');
      } catch (error) {
        setIsServerAvailable(false);
      }
    };

    checkServerHealth();
  }, []);

  useEffect(() => {
    setIframeKey((prev) => prev + 1);
  }, [locale]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data.type === 'NAVIGATE') {
        const url = new URL(event.data.url);
        navigate(url.pathname + url.search);
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [navigate]);

  if (!isServerAvailable) {
    return null;
  }

  return (
    <>
      <FloatButton
        type="primary"
        shape="circle"
        icon={
          isOpen ? (
            <CloseOutlined style={{ fontSize: 30 }} />
          ) : (
            <AliwangwangOutlined style={{ fontSize: 30 }} />
          )
        }
        onClick={() => setIsOpen(!isOpen)}
        style={{ height: 56, width: 56, right: 20, bottom: 86, zIndex: 1001 }}
        tooltip="Chat with POS AI Assistant"
      />

      <ChatContainer variant="borderless" $isOpen={isOpen}>
        <Iframe
          key={iframeKey}
          src={`https://pos-agent-aws.inventorum.com/?token=${userToken}&locale=${locale}`}
          title="AI Chat"
          allow="clipboard-write"
        />
      </ChatContainer>
    </>
  );
};

export default Agent;
